import { render, staticRenderFns } from "./DropDisabilities.vue?vue&type=template&id=423480a2&"
import script from "./DropDisabilities.vue?vue&type=script&lang=js&"
export * from "./DropDisabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports